import {
  mdiApi,
  mdiDatabaseSearchOutline,
  mdiDownloadOutline,
  mdiEyeOutline,
  mdiShareVariantOutline,
  mdiTools,
} from '@mdi/js';

const ACTION_ICONS = Object.freeze({
  read: mdiEyeOutline,
  export: mdiDownloadOutline,
  use: mdiTools,
  share: mdiShareVariantOutline,
  receive: mdiApi,
});

const NAMESPACE_ICONS = Object.freeze({
  dataset: mdiDatabaseSearchOutline,
  integration: mdiApi,
  tool: mdiTools,
  capability: mdiApi,
});

function titleCase(value) {
  return String(value || '')
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

function tryTranslate(t, key) {
  const translated = t(key);
  if (typeof translated !== 'string') {
    return null;
  }
  const normalized = translated.trim();
  return normalized && normalized !== key ? normalized : null;
}

export function grantDisplayFor(key, t) {
  const [namespace = '', entity = '', action = ''] = String(key || '').split('.');
  const namespaceLabel = tryTranslate(t, `grants.namespaces.${namespace}`) || titleCase(namespace);
  const entityLabel =
    (entity === '*' ? tryTranslate(t, 'grants.entities.all') : null) ||
    tryTranslate(t, `grants.entities.${namespace}.${entity}`) ||
    titleCase(entity);
  const actionLabel = tryTranslate(t, `grants.actions.${action}`) || titleCase(action);
  const pattern = tryTranslate(t, 'grants.label_pattern') || '{namespace}: {entity}';

  return {
    key,
    namespaceLabel,
    entityLabel,
    label: pattern
      .replace('{namespace}', namespaceLabel)
      .replace('{entity}', entityLabel)
      .replace('{action}', actionLabel),
    actionLabel,
    icon: ACTION_ICONS[action] || NAMESPACE_ICONS[namespace] || mdiApi,
  };
}
